import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { OccupancyProvider } from './context/OccupancyContext';
import ProtectedRoute from './components/ui/ProtectedRoute';

// Public / Visitor pages
import RegisterForm from './pages/visitor/RegisterForm';
import QRConfirmation from './pages/visitor/QRConfirmation';

// Auth
import LoginPage from './pages/LoginPage';

// Security guard pages
import ScanPage from './pages/security/ScanPage';
import ManualEntryForm from './pages/security/ManualEntryForm';
import SecurityVisitorsPage from './pages/security/VisitorsPage';

// Staff pages
import StaffEventManagement from './pages/staff/EventManagement';
import StaffVipVisitorsPage from './pages/staff/VipVisitorsPage';

// Admin pages
import MembersList from './pages/admin/MembersList';
import Analytics from './pages/admin/Analytics';
import UserManagement from './pages/admin/UserManagement';
import AdminVisitorRegistration from './pages/admin/VisitorRegistration';

import AdminLayout from './components/layout/AdminLayout';
import './App.css';

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <OccupancyProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Navigate to="/register" replace />} />
            <Route path="/register" element={<RegisterForm />} />
            <Route path="/confirmation" element={<QRConfirmation />} />
            <Route path="/login" element={<LoginPage />} />

            {/* Logged-in Dashboard routes with shared shell */}
            <Route element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              {/* Security guard routes */}
              <Route path="/guard" element={
                <ProtectedRoute allowedRoles={['security', 'admin']}>
                  <ScanPage />
                </ProtectedRoute>
              } />
              <Route path="/guard/manual" element={
                <ProtectedRoute allowedRoles={['security', 'admin']}>
                  <ManualEntryForm />
                </ProtectedRoute>
              } />
              <Route path="/guard/visitors" element={
                <ProtectedRoute allowedRoles={['security', 'admin']}>
                  <SecurityVisitorsPage />
                </ProtectedRoute>
              } />

              {/* Staff routes */}
              <Route path="/staff/events" element={
                <ProtectedRoute allowedRoles={['staff', 'admin']}>
                  <StaffEventManagement />
                </ProtectedRoute>
              } />
              <Route path="/staff/vips" element={
                <ProtectedRoute allowedRoles={['staff', 'admin']}>
                  <StaffVipVisitorsPage />
                </ProtectedRoute>
              } />

              {/* Admin routes */}
              <Route path="/admin/members" element={
                <ProtectedRoute allowedRoles={['admin']}>
                  <MembersList />
                </ProtectedRoute>
              } />
              <Route path="/admin/members/new" element={
                <ProtectedRoute allowedRoles={['admin']}>
                  <AdminVisitorRegistration />
                </ProtectedRoute>
              } />
              <Route path="/admin/analytics" element={
                <ProtectedRoute allowedRoles={['admin']}>
                  <Analytics />
                </ProtectedRoute>
              } />
              <Route path="/admin/users" element={
                <ProtectedRoute allowedRoles={['admin']}>
                  <UserManagement />
                </ProtectedRoute>
              } />
            </Route>

            {/* Catch-all */}

            {/* Catch-all */}
            <Route path="*" element={<Navigate to="/register" replace />} />
          </Routes>
        </OccupancyProvider>
      </AuthProvider>
    </Router>
  );
}
